import produce from 'immer';
import { setUserActionRequestState } from '../utils/belay_helpers';

export const SET_OVERRIDE_USER = 'SET_OVERRIDE_USER';
export const setOverrideUser = userConnection => {
  return {
    type: SET_OVERRIDE_USER,
    payload: userConnection
  };
};

export const updateUserActionRequestState = (userConnection, actionKey, requestState) => {
  return dispatch => {
    const updatedUserConnection = setUserActionRequestState(userConnection, actionKey, requestState);
    dispatch(setOverrideUser(updatedUserConnection));
  };
};

export const defaultUserOverrides = {};

// disabled default case because Immer automatically returns a default case
/* eslint-disable default-case, no-unused-expressions */
const userOverrides = produce((draftState, action) => {
  switch (action.type) {
    case SET_OVERRIDE_USER:
      draftState[action.payload.user.id] = action.payload;
      break;
  }
}, defaultUserOverrides);

export default userOverrides;
